import { useEffect, useState } from 'react'
import { useEdgeDataGetProspect, useEdgePatchProspectOffer, useEdgeDataProspectDocuments, useEdgePatchProspectOptions, useEdgeDataProspectQx } from './useEdgeDataFetcher'
import { SummaryPageNumber, OptionsPageNumber, CertificatePageNumber, ContactPageNumber, AftermarketPageNumber } from '../constants'

export default (landingContext, contactInfo) => {
  const [_prospectId, setProspectId] = useState(landingContext.urlState.prospectId)
  const isAdmin = landingContext.experienceState.isAdmin
  const isAssigned = landingContext.experienceState.isAssigned
  const isCobrand = landingContext.experienceState && landingContext.experienceState.isCobrand
  const allowIneligibleVehicle = landingContext.experienceState.allowIneligibleVehicle && isCobrand
  const isAssignedOrCobranding = isAssigned || allowIneligibleVehicle

  const step = landingContext.urlState.p
  const lastStep = landingContext.urlState.lp
  const canProspect =
    (landingContext.locationState.click || step === SummaryPageNumber || isAdmin || !!landingContext.urlState.prospectId) &&
    (step >= AftermarketPageNumber || lastStep >= AftermarketPageNumber) &&
    step < CertificatePageNumber &&
    !(isAdmin && landingContext.offer && step === ContactPageNumber)
  const canPatchProspect = landingContext.engine && landingContext.transmission && landingContext.drivetrain && true
  const offerId = landingContext.offer && landingContext.offer.offerId
  const offer = landingContext.offer
  const newProspectData = canProspect && !offerId && getProspectReq(landingContext, contactInfo)
  const editOfferProspectData = canProspect && offerId && landingContext.offer
  const [prospect, renewErrors, isFetchingProspect] = useEdgeDataGetProspect(newProspectData, editOfferProspectData, !isAdmin, landingContext.urlState, _prospectId, isAssignedOrCobranding)
  useEffect(() => {
    // auto renew prospect if urlState.prospectId is invalid
    if (_prospectId && renewErrors.length) {
      setProspectId(null)
    }
  }, [renewErrors.length, isFetchingProspect, _prospectId])

  const isFetchingProspectRenew = isFetchingProspect
  landingContext.prospect = prospect
  landingContext.renewErrors = renewErrors
  landingContext.prospectId = landingContext.prospect && landingContext.prospect.prospectId
  landingContext.setLoadingInfo('Updating Information', isFetchingProspect)
  landingContext.urlState.prospectId = landingContext.prospectId
  const prospectId = prospect && prospect.prospectId
  if (prospectId) landingContext.setHistoryUrlState()
  const [isProspectSet, setIsProspectSet] = useState(!!prospect)
  useEffect(() => {
    if (canProspect) setIsProspectSet(!!prospectId)
  }, [prospectId, canProspect])
  landingContext.isProspectSet = isProspectSet
  landingContext.setIsProspectSet = setIsProspectSet
  const vinCheck = landingContext.vinModalInfo.vinCheck //do not patch yet if resolved vin is a mismatch for the offer, vinModal will display here
  const [prospectPatched, , isFetchingProspectOfferPatch] = useEdgePatchProspectOffer(!vinCheck && landingContext.prospectId, offerId && getProspectReq(landingContext, contactInfo), offerId, isAdmin, offer)
  landingContext.prospectPatched = prospectPatched
  const [, , isFetchingProspectOptionsPatch] = useEdgePatchProspectOptions(
    !isFetchingProspectOfferPatch && !isFetchingProspect && canPatchProspect && landingContext.prospectId,
    landingContext.prospectId && constructOptions(landingContext),
    landingContext.vinResults,
    landingContext.offer
  )
  landingContext.setLoadingInfo('Updating Information', isFetchingProspectOfferPatch || isFetchingProspectOptionsPatch)

  const [prospectDocuments, , isFetchingProspectDocuments] = useEdgeDataProspectDocuments(landingContext.prospectId)
  landingContext.prospectDocuments = prospectDocuments
  landingContext.setLoadingInfo('Getting Questions', isFetchingProspectDocuments)

  const [prospectQx] = useEdgeDataProspectQx(landingContext.prospectId)
  landingContext.consumerGenerated = (prospectQx ? prospectQx.find(x => x && x.questionId === 'qx/ConsumerGenerated') : {}).value

  let loadingProspectDocuments = false
  const isOutageError = landingContext.globalState && landingContext.globalState.isOutageError
  const prospectIdParam = landingContext.urlState && landingContext.urlState.pa && landingContext.urlState.pa[0] && landingContext.urlState.pa[0].indexOf('prospect') === 0 && landingContext.urlState.pa[1]
  //created prospect, not certificate page
  if (!landingContext.prospectDocuments && landingContext.urlState.p >= AftermarketPageNumber) {
    if ((!offerId && !(isOutageError || prospectIdParam)) || isFetchingProspectRenew || (renewErrors && renewErrors.length)) {
      loadingProspectDocuments = landingContext.locationState.click
      landingContext.urlState.p = OptionsPageNumber
      landingContext.urlState.pp = (landingContext.urlState.pp || 0) + 1 //need to set another variable so that next click to p=2 again will trigger a url change
    } else landingContext.prospectDocuments = {}
  }

  const [loading, setLoading] = useState(false)
  useEffect(() => {
    let mounted = true
    setTimeout(() => mounted && setLoading(loadingProspectDocuments), 200)
    setTimeout(() => mounted && setLoading(false), 10000) //if error loading 5 secs, open back
    return () => (mounted = false)
  }, [loadingProspectDocuments])
  landingContext.loadingProspectDocuments = loading && loadingProspectDocuments
}

const constructOptions = ({ urlState }) => {
  var allOptions = []
  const userOptions = urlState.o
  userOptions &&
    userOptions.forEach(option => {
      const isSelected = option.replace(/\d+/, '') === 'T'
      const optionId = option.replace(/[^\d]/, '')
      allOptions.push({ optionId, isSelected })
    })
  return allOptions
}

const getVehicle = ({ year, make, model, trim, color, transmission, engine, drivetrain, vinResults, offer }) =>
  year && make && model && trim && color && transmission && engine && drivetrain
    ? {
        yearId: vinResults && vinResults.cadsUsed ? vinResults.year.yearId : year.yearId,
        makeId: vinResults && vinResults.cadsUsed ? vinResults.make.makeId : make.makeId,
        modelId: vinResults && vinResults.cadsUsed ? vinResults.model.modelId : model.modelId,
        trimId: vinResults && vinResults.cadsUsed ? vinResults.trim?.trimId : trim.trimId,
        colorId: vinResults && vinResults.colorsVinVerified ? vinResults.colors[0].colorId : color.colorId,
        transmissionId: vinResults && vinResults.transmissionsVinVerified ? vinResults.transmissions[0].transmissionId : transmission.transmissionId,
        engineId: vinResults && vinResults.enginesVinVerified ? vinResults.engines[0].engineId : engine.engineId,
        drivetrainId: vinResults && vinResults.drivetrainsVinVerified ? vinResults.drivetrains[0].drivetrainId : drivetrain.drivetrainId
      }
    : null

const getVehicleBuildDataFlags = ({ vinResults }) =>
  vinResults && vinResults.cadsUsed
    ? {
        cadsUsed: vinResults.cadsUsed,
        transmissionsVinVerified: vinResults.transmissionsVinVerified,
        enginesVinVerified: vinResults.enginesVinVerified,
        drivetrainsVinVerified: vinResults.drivetrainsVinVerified,
        optionsVinVerified: vinResults.optionsVinVerified,
        colorsVinVerified: vinResults.colorsVinVerified
      }
    : {
        cadsUsed: false,
        transmissionsVinVerified: false,
        enginesVinVerified: false,
        drivetrainsVinVerified: false,
        optionsVinVerified: false,
        colorsVinVerified: false
      }

const getSdSessionId = exprState => {
  if (!window.ICO_isSDLoaded) return undefined
  const { isStellantisDealer, isToyotaDealer, oemDealerCode, isLexusDealer, isGMDealer, isGenesisDealer } = exprState
  if (oemDealerCode && (isStellantisDealer || isToyotaDealer || isLexusDealer || isGMDealer || isGenesisDealer)) return window.sd.SessionId
  return undefined
}

const getProspectReq = (landingContext, contactInfo) => {
  const vehicle = getVehicle(landingContext)
  const vehicleBuildDataFlags = getVehicleBuildDataFlags(landingContext)
  const { experienceState, urlState, modifiedFromOfferId, mileage } = landingContext
  const isConsumerOffer = !experienceState.isAdmin ? true : experienceState.dealerInfo.isConsumerOffer || (landingContext.offer && landingContext.offer.prospect && landingContext.offer.prospect.isConsumerOffer) ? true : false
  const dealerRepId = landingContext.globalState.dealerRepId || (experienceState.dealerInfo ? experienceState.dealerInfo.dealerRepId || 0 : 0)
  const inviteId = experienceState.dealerInviteId
  const dealerPickupSVOCID = experienceState.dealerPickupSVOCID
  const sdSessionId = getSdSessionId(experienceState)
  const isAssigned = experienceState && experienceState.isAssigned
  const isAdmin = experienceState && experienceState.isAdmin
  const isIneligibleVehiclesEnabled = experienceState && experienceState.isIneligibleVehiclesEnabled
  const autoCheckData = (isIneligibleVehiclesEnabled ? isAssigned : '') && JSON.stringify(landingContext.autoCheckData)

  if (vehicle) vehicle.vin = urlState.vin || ''
  const prospect = {
    vehicle,
    mileage,
    contactInfo,
    isConsumerOffer,
    channelId: 'e8f21a4b-7b53-4004-a5ee-21b35d4ed06c',
    modifiedFromOfferId,
    inviteId,
    dealerPickupSVOCID,
    vehicleBuildDataFlags,
    sdSessionId,
    autoCheckData
  }

  if (experienceState.groupId) prospect.cobranding = { groupId: experienceState.groupId }
  if (experienceState.dealerId) prospect.dealerId = experienceState.dealerId
  if (dealerRepId) prospect.dealerRepId = dealerRepId
  if (experienceState.dealerRepName) prospect.dealerRepName = experienceState.dealerRepName

  if (!vehicle || !mileage || (isAdmin && !vehicle.vin)) return undefined
  return prospect
}
